export default {
  hi_im_neela: 'Merhaba, ben Neela,',
  english: 'English',
  german: 'Deutsch',
  french: 'Français',
  dutch: 'Nederlands',
  swedish: 'Svenska',
  ukrainian: 'Українці',
  turkish: 'Türkçe',
  russian: 'Русский',
  spanish: 'Español',
  italian: 'Italiano',
  arabic: 'عربي',
  aareons_virtual: "Aareon''un sanal asistanıyım.",
  media: 'Medya',
  media_link: 'https://neela.aareon.de/media',
  contact: 'İletişim',
  contact_link: 'https://neela.aareon.de/contact',
  privacy: 'Veri koruma',
  privacy_link: 'https://www.aareon.de/sixcms/detail.php/46076',
  terms_of_use: 'Kullanım Koşulları',
  terms_of_use_link:
    'https://www.aareon.com/Allgemeine_Informationen/Nutzungsbedingungen.2366.html',
  legal_notice: 'Künye',
  legal_notice_link: 'https://neela.aareon.de/legal',
  show_system_messages: 'Sistem mesajlarını görüntüleme',
  dont_show_system_messages: 'Sistem mesajlarını gizleme',
  logged_in: 'Kiracının kimliği doğrulandı',
  logged_out: 'Anonim kullanıcı',
  button_switch_locale: 'Dili değiştir',
  button_tooltip_activate_voice_recognition: 'Konuşma tanımayı etkinleştirin',
  date_input: 'Tarih seçiniz',
  choose_two_dates: 'Lütfen iki tarih seçin',
  date_range: 'Tarih aralığı',
  from: 'itibaren',
  to: 'için',
  avatar: 'Avatar',
  exit: 'Bitiş',
  new: 'Yeni',
  back: 'Geri',
  suggestions: 'Öneriler',
  senton: 'Gönderildi',
  message_placeholder: 'Mesajınızı buraya girin',
  comment_placeholder: 'Yorumu buraya girin',
  file_max_upload_text: 'En fazla 20 dosya yüklenebilir',
  message_button_label: 'Gönder',
  please_confirm: 'Lütfen onaylayın',
  no: 'Hayır',
  yes: 'Evet',
  modal_delete_session: 'Oturumu sil',
  modal_delete_session_notification:
    'Pencereyi kapattığınızda oturumunuz da silinecektir.<br>Kabul ediyor musunuz?',
  template_contact_time: 'Sizinle ne zaman iletişime geçebiliriz?',
  template_pause:
    'Oturumunuz duraklatıldı. Destek personelimizden biri kısa süre içinde talebinizle ilgilenecektir.',
  template_continue_after_pause:
    'Oturumunuz yeniden başlatıldı. Artık sohbet robotumuzla yazmaya devam edebilirsiniz.',
  button_apply: 'Başvur',
  button_cancel: 'İptal',
  none: 'Hiçbiri',
  book_appointment: 'Randevu alın',
  address_input: 'Adres girişi',
  data_processing: 'Veri işleme',
  privacy_policy: 'gizlilik politikasını',
  data_processing_notification_before_link:
    'Bu sohbet hizmetini kullanabilmeniz için ',
  data_processing_notification_after_link: 'kabul etmeniz gerekmektedir.',
  button_accept: 'Kabul',
  select_date: 'Tarih seçiniz',
  rate_conversation: 'Bu konuşmayı nasıl değerlendirirsiniz?',
  new_ticket_question: 'Sizin için yapabileceğim başka bir şey var mı?',
  thank_you:
    'Desteğiniz için teşekkür ederiz. Geri bildirimleriniz her zaman gelişmeme yardımcı oluyor.',
  goodbye: 'Yakında görüşürüz.',
  start_new: 'Yeni bir konuşma başlatın',
  operator_entered_the_chat: 'Operator entered the chat',
  operator_left_the_chat: 'Operator has left the chat',
  bg_image: process.env.VUE_APP_DE_BG,
  expand_quickreplies: 'Daha çok',
  collapse_quickreplies: 'Daha az',
  login: 'Sisteme girmek ',
  logout: 'Sistemden çıkmak',
  close: 'Kapat',
  upload_file: 'Yüklenecek dosyayı buraya yerleştirin ',
  upload_file_or: 'veya ',
  Upload_file_select: 'dosyaları buraya ekleyin',
  upload_file_text: 'Yüklenecek dosya',
  show_attachments: 'Eki göster',
  hide_attachments: 'Eki gizle',
  maximize: 'Büyütmek',
  minimize: 'Küçültmek',
  feedback_helpful: 'Bu cevap bana yardımcı oldu',
  feedback_not_helpful: 'Bu cevap bana yardımcı olmadı',
  showMore: 'Daha fazla göster',
  showLess: 'Daha az göster',
  feedbackDescription: 'Öneriniz var mı',
  feedbackSubtitle: {
    description:
      'Buradan bize genel önerilerinizi, tekliflerinizi ve taleplerinizi gönderebilirsiniz.',
    note: 'Lütfen bunlara yanıt veremeyeceğimizi unutmayın.',
    hint:
      'Özellikle kiracılığınızla veya daire arayışınızla ilgili diğer tüm endişelerinizi bize sohbet sırasında anlatabilirsiniz.'
  },
  feedbackPlaceholder: 'Mesajınızı buraya girin...',
  sendFeedback: 'Gönder',
  giveFeedback: 'Öneriniz var mı',
  feedbackSubmittedSuccessfully: 'Geri bildiriminiz başarıyla gönderildi'
}
